import React from "react";
import { Text } from "@fragments";
import { LocalOfferRounded } from "@mui/icons-material";
import AvailabilityInPlan from "@components/AvailabilityInPlan";

export default function Availability({ value, onChange, community }) {
    return (
        <>
            <Text.h3
                value="Disponibilidade"
                left={<LocalOfferRounded />}
                className="mb-1 mt-5"
            />
            <AvailabilityInPlan
                community={community}
                initialValues={value?.plans}
                onChange={onChange}
            />
        </>
    );
}
